import debounce from 'debounce';
class Modal extends HTMLElement {
  constructor() {
    super();
    this._dialog = null;
    this._previousFocus = null;
  }
  connectedCallback() {
    // Get the dialog element
    this._dialog = this.querySelector('dialog');
    if (this._dialog) {
      // Event delegation - listen for clicks on the modal
      this.addEventListener('click', event => {
        // Check if the clicked element has data-action='close'
        if (event.target.closest('[data-action="close"]')) {
          event.preventDefault();
          this.close();
        } else {
          const rect = this._dialog.getBoundingClientRect();

          // Check if click is outside the dialog's boundaries
          if (rect.left > event.clientX || rect.right < event.clientX || rect.top > event.clientY || rect.bottom < event.clientY) {
            this.close();
          }
        }
      });

      // Handle escape key
      this._dialog.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.close();
        }
      });
    }

    // bindings
    this.bndHandleResize = debounce(this.handleResize.bind(this), 250);

    // events
    window.addEventListener('resize', this.bndHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.bndHandleResize);

    // No need to clean up specific close button - we're using event delegation now
  }
  handleResize() {
    // Implement resize handling if needed
  }
  open() {
    if (this._dialog) {
      this._previousFocus = document.activeElement;
      if (typeof this._dialog.showModal === 'function') {
        this._dialog.showModal();
      } else {
        // Fallback for browsers not supporting <dialog>
        this._dialog.setAttribute('open', '');
      }

      // Focus first focusable element
      setTimeout(() => {
        const focusable = this._dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable.length) {
          focusable[0].focus();
        }
      }, 100);

      // Dispatch event
      this.dispatchEvent(new CustomEvent('modal:opened'));
    }
  }
  close() {
    if (this._dialog) {
      if (typeof this._dialog.close === 'function') {
        this._dialog.close();
      } else {
        // Fallback for browsers not supporting <dialog>
        this._dialog.removeAttribute('open');
      }

      // Restore focus
      if (this._previousFocus && this._previousFocus.focus) {
        this._previousFocus.focus();
      }

      // Dispatch event
      this.dispatchEvent(new CustomEvent('modal:closed'));
    }
  }
}
customElements.define('modal-dialog', Modal);